import { render, staticRenderFns } from "./Bando33Fase3.vue?vue&type=template&id=812861d2&scoped=true"
import script from "./Bando33Fase3.vue?vue&type=script&lang=js"
export * from "./Bando33Fase3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812861d2",
  null
  
)

export default component.exports